import { render, staticRenderFns } from "./JdhPageSectionNarrow.vue?vue&type=template&id=11d83e0e&scoped=true&"
import script from "./JdhPageSectionNarrow.vue?vue&type=script&lang=ts&"
export * from "./JdhPageSectionNarrow.vue?vue&type=script&lang=ts&"
import style0 from "./JdhPageSectionNarrow.vue?vue&type=style&index=0&id=11d83e0e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d83e0e",
  null
  
)

export default component.exports